import React, { useEffect, useState } from "react";
import { Plus, Pencil, Trash2, Users, Search } from "lucide-react";
import { Tooltip } from "@mui/material";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";
import user1 from "../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiCalendar } from "react-icons/fi";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import InactiveTeams from "./InactiveTeams";
dayjs.extend(relativeTime);

const TeamManagement = ({ teams, setTeams, fetchInactiveList }) => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  //   const [teams, setTeams] = useState([]);

  // const [teams, setTeams] = useState([
  //   {
  //     id: 1,
  //     name: "Software Development",
  //     department: "Technology",
  //     manager: "Ahmed Khan",
  //     isActive: false,
  //     members: [
  //       {
  //         employeeId: "EMP001",
  //         name: "John Doe",
  //         designation: "Senior Developer",
  //         role: "Team Lead",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP002",
  //         name: "Maria Smith",
  //         designation: "Frontend Developer",
  //         role: "Member",
  //         status: "Active",
  //       },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     name: "Quality Assurance",
  //     department: "Technology",
  //     manager: "Sarah Johnson",
  //     isActive: false,
  //     members: [
  //       {
  //         employeeId: "EMP003",
  //         name: "David Lee",
  //         designation: "QA Engineer",
  //         role: "Team Lead",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP004",
  //         name: "Emily White",
  //         designation: "Automation Tester",
  //         role: "Member",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP005",
  //         name: "James Brown",
  //         designation: "Manual Tester",
  //         role: "Member",
  //         status: "On Leave",
  //       },
  //     ],
  //   },
  //   {
  //     id: 3,
  //     name: "Product Management",
  //     department: "Product",
  //     manager: "Lisa Ray",
  //     isActive: false,
  //     members: [
  //       {
  //         employeeId: "EMP006",
  //         name: "Michael Chen",
  //         designation: "Product Owner",
  //         role: "Team Lead",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP007",
  //         name: "Sophia Martinez",
  //         designation: "Business Analyst",
  //         role: "Member",
  //         status: "Active",
  //       },
  //     ],
  //   },
  //   {
  //     id: 4,
  //     name: "DevOps & Infrastructure",
  //     department: "Technology",
  //     manager: "Omar Hassan",
  //     isActive: false,
  //     members: [
  //       {
  //         employeeId: "EMP008",
  //         name: "Robert Taylor",
  //         designation: "DevOps Engineer",
  //         role: "Team Lead",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP009",
  //         name: "Linda Green",
  //         designation: "Cloud Architect",
  //         role: "Member",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP010",
  //         name: "Kevin Adams",
  //         designation: "System Admin",
  //         role: "Member",
  //         status: "Active",
  //       },
  //     ],
  //   },
  //   {
  //     id: 5,
  //     name: "Customer Support",
  //     department: "Operations",
  //     manager: "Nadia Abbas",
  //     isActive: false,
  //     members: [
  //       {
  //         employeeId: "EMP011",
  //         name: "Rachel Kim",
  //         designation: "Support Lead",
  //         role: "Team Lead",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP012",
  //         name: "Carlos Mendez",
  //         designation: "Technical Support",
  //         role: "Member",
  //         status: "Active",
  //       },
  //       {
  //         employeeId: "EMP013",
  //         name: "Anna Wilson",
  //         designation: "Customer Success",
  //         role: "Member",
  //         status: "Inactive",
  //       },
  //     ],
  //   },
  // ]);

  useEffect(() => {
    fetchInactiveList();
  }, []);

  console.log("Inactive teams:", teams);

  const users = [
    "Ahmed Khan",
    "Fatima Alavi",
    "Raghu",
    "Suresh",
    "Maria",
    "John",
    "Priya",
    "Omar Hassan",
    "Lakshmi",
    "Carlos",
  ];

  const roles = [
    "Team Lead",
    "Senior Employee",
    "Employee",
    "Intern",
    "HR Coordinator",
    "Supervisor",
  ];

  const departments = [
    "Human Resources",
    "Technology",
    "Finance",
    "Sales",
    "Marketing",
    "Operations",
    "Customer Support",
  ];

  const employeeStatus = [
    "Active",
    "On Leave",
    "Probation",
    "Notice Period",
    "Resigned",
    "Terminated",
  ];

  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [editingTeam, setEditingTeam] = useState(null);
  const [loader, setLoader] = useState(false);
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;
  const [searchdata, setSearchData] = useState("");
  const [resetalldata, setResetallData] = useState(false);
  const [allEmpRecords, setAllEmpRecords] = useState([]);
  const [leaderSearch, setLeaderSearch] = useState("");
  const [memberSearch, setMemberSearch] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [teamToDelete, setTeamToDelete] = useState(null);

  const fetchProfilePic = (ImagePath) => {
    if (!ImagePath) return user1;
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop();
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  const [formData, setFormData] = useState({
    name: "",
    owner: "",
    members: [],
    date: new Date(),
    isActive: true,
  });

  useEffect(() => {
    console.log("Formdata:", formData);
  }, [formData]);

  const openAddModal = () => {
    setEditingTeam(null);
    setFormData({
      name: "",
      owner: "",
      members: [],
    });
    setIsOpen(true);
  };

  const openEditModal = (team) => {
    setEditingTeam(team);
    setFormData(team);
    setIsOpen(true);
  };

  const saveTeam = () => {
    if (!formData.name || !formData.owner.ownerid) return;

    if (editingTeam) {
      setTeams((prev) =>
        prev.map((t) =>
          t.id === editingTeam.id ? { ...editingTeam, ...formData } : t,
        ),
      );
    } else {
      setTeams((prev) => [
        ...prev,
        {
          id: Date.now(),
          ...formData,
        },
      ]);
    }

    setIsOpen(false);
  };

  const deleteTeam = () => {
    if (!teamToDelete) return;

    setTeams((prev) => prev.filter((t) => t.id !== teamToDelete.id));

    setDeleteModalOpen(false);
    setTeamToDelete(null);
  };

  const filteredTeams = teams?.filter((team) => {
    const searchValue = search.toLowerCase();

    return (
      team.TeamName?.toLowerCase().includes(searchValue) ||
      team.TeamLeaderName?.toLowerCase().includes(searchValue) ||
      team.members?.some((m) =>
        m.EmployeeName.toLowerCase().includes(searchValue),
      )
    );
  });

  console.log("filteredTeams:", filteredTeams);

  const disableSaveTeam = !formData.name || !formData.owner.ownerid;
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoader(true);
    try {
      const isSearchEmpty = !searchdata || searchdata.trim() === "";

      const searchType = isSearchEmpty || resetalldata ? "ALL" : "FREETEXT";
      const searchParam = isSearchEmpty || resetalldata ? "ALL" : searchdata;

      const response = await axios.get(
        // `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/${empStatus}/${searchParam}/${jobTitleParam}/${gradeParam}/${divisionParam}`,

        // working static down..|
        `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/YES/${searchParam}/ALL/ALL/ALL`,

        // working dynamic down..|
        // `${base_url}/api/PersonalInfoList/${companyCode}/${searchType}/YES/${searchParam}/${jobTitleSelected}/ALL/${selectedDivision}`,
      );
      const data = response.data;
      console.log("Data Employee List:", data);
      // setRecords(data);
      setAllEmpRecords(data);
    } catch (error) {
      console.error("Error fetching data:", error);
      // toast.error("Error fetching employee data");
    } finally {
      setLoader(false);
      if (resetalldata) setResetallData(false);
    }
  };

  console.log("Emp Records:", allEmpRecords);

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [isTeamNameEditable, setIsTeamNameEditable] = useState(false);
  const [pendingMember, setPendingMember] = useState(null);

  // Modified toggleMember function with duplicate check
  const toggleMember = (user) => {
    const existing = formData.members.find((m) => m.employeeId === user.EmpId);

    if (existing) {
      // Remove member if already selected
      setFormData({
        ...formData,
        members: formData.members.filter((m) => m.employeeId !== user.EmpId),
      });
    } else {
      // Check if member already exists in ANY team (for edit mode)
      if (editingTeam) {
        // Check if this employee is already in the current team being edited
        const isInCurrentTeam = editingTeam.members.some(
          (m) => m.employeeId === user.EmpId,
        );

        if (isInCurrentTeam) {
          // Show confirmation popup
          setPendingMember(user);
          setShowConfirmDialog(true);
          return;
        }
      }

      // Add new member
      addMemberToTeam(user);
    }
  };

  // Function to add member to team
  const addMemberToTeam = (user) => {
    setFormData({
      ...formData,
      members: [
        ...formData.members,
        {
          employeeId: user.EmpId,
          name: user.Name,
          designation: user.JobTitle || "Employee",
          role: user.Division || "Member",
          status: "Active",
          employeeImage: user.imagepath || null,
          isActive: true,
        },
      ],
    });
  };

  // Function to confirm adding duplicate member
  const confirmAddDuplicate = () => {
    if (pendingMember) {
      addMemberToTeam(pendingMember);
      setShowConfirmDialog(false);
      setPendingMember(null);
    }
  };

  // Update role function (keep as is)
  const updateRole = (employeeId, newRole) => {
    setFormData({
      ...formData,
      members: formData.members.map((member) =>
        member.employeeId === employeeId
          ? { ...member, role: newRole }
          : member,
      ),
    });
  };
  const selectedLeader = allEmpRecords.find(
    (emp) => emp.EmpId === formData.owner.ownerid,
  );





  // Add this confirmation modal component inside your main component, before the main modal
  const ConfirmationDialog = () => {
    if (!showConfirmDialog) return null;

    return (
      <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50">
        <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl animate-in fade-in zoom-in duration-200">
          <div className="text-center">
            <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
              <svg
                className="h-6 w-6 text-yellow-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
            <h3 className="mb-2 text-xl font-semibold text-slate-800">
              Member Already Exists
            </h3>
            <p className="mb-6 text-slate-600">
              <span className="font-medium">{pendingMember?.Name}</span> (
              {pendingMember?.EmpId}) is already a member of this team.
              <br />
              Do you still want to add them?
            </p>
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowConfirmDialog(false);
                  setPendingMember(null);
                }}
                className="flex-1 rounded-xl border border-slate-300 px-4 py-2 font-medium text-slate-700 transition hover:bg-slate-50"
              >
                Cancel
              </button>
              <button
                onClick={confirmAddDuplicate}
                className="flex-1 rounded-xl bg-yellow-600 px-4 py-2 font-medium text-white transition hover:bg-yellow-700"
              >
                Yes, Add Anyway
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Also add a check for create mode to prevent duplicates across different teams
  // Add this function to check if employee is already in any team (for create mode)
  const isEmployeeInAnyTeam = (employeeId, currentTeamId = null) => {
    return teams.some(
      (team) =>
        team.id !== currentTeamId &&
        team.members.some((member) => member.employeeId === employeeId),
    );
  };

  // Update the toggleMember function for create mode:
  const toggleMemberWithGlobalCheck = (user) => {
    const existing = formData.members.find((m) => m.employeeId === user.EmpId);

    if (existing) {
      setFormData({
        ...formData,
        members: formData.members.filter((m) => m.employeeId !== user.EmpId),
      });
    } else {
      // For create mode, check if employee is already in any other team
      if (!editingTeam && isEmployeeInAnyTeam(user.EmpId)) {
        setPendingMember(user);
        setShowConfirmDialog(true);
        return;
      }

      addMemberToTeam(user);
    }
  };

  const availableMembers = allEmpRecords.filter(
    (emp) => emp.EmpId !== formData.owner.ownerid,
  );

  console.log("formData.members:", formData.members);

  // const toggleTeamStatus = (teamId) => {
  //   setTeams((prev) =>
  //     prev.map((team) =>
  //       team.id === teamId ? { ...team, isActive: !team.isActive } : team,
  //     ),
  //   );
  // };

  const toggleTeamStatus = async (teamId, currentStatus) => {
    try {
      const storeduserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

      const companyCode = storeduserDataArray?.[0]?.cmpcode || "";

      const newStatus = currentStatus === "Y" ? "N" : "Y";

      await axios.get(
        `${base_url}/api/CRMStatusUpdate/${companyCode}/TEAMACTIVE/${teamId}/${newStatus}`,
      );

      setTeams((prev) =>
        prev.map((team) =>
          (team.TeamID || team.id) === teamId
            ? {
              ...team,
              ActiveStatus: newStatus,
              isActive: newStatus === "Y",
            }
            : team,
        ),
      );

      console.log("updated team status:");
      fetchInactiveList();
      // setSnackbar({
      //   open: true,
      //   message: `Team ${
      //     newStatus === "Y" ? "activated" : "deactivated"
      //   } successfully`,
      //   severity: "success",
      // });
    } catch (error) {
      console.error("Error updating team status:", error);

      // setSnackbar({
      //   open: true,
      //   message: "Failed to update team status",
      //   severity: "error",
      // });
    }
  };

  const filteredLeaders = [...allEmpRecords]
    .filter((emp) => {
      const search = leaderSearch.toLowerCase();

      return (
        emp.Name?.toLowerCase().includes(search) ||
        emp.EmpId?.toLowerCase().includes(search) ||
        emp.Department?.toLowerCase().includes(search) ||
        emp.JobTitle?.toLowerCase().includes(search)
      );
    })
    .sort((a, b) => {
      if (a.EmpId === formData.owner.ownerid) return -1;
      if (b.EmpId === formData.owner.ownerid) return 1;
      return 0;
    });

  const filteredMembers = allEmpRecords
    .filter((emp) => {
      const search = memberSearch.toLowerCase();

      return (
        emp.EmpId !== formData.owner.ownerid &&
        (emp.Name?.toLowerCase().includes(search) ||
          emp.EmpId?.toLowerCase().includes(search) ||
          emp.Department?.toLowerCase().includes(search) ||
          emp.JobTitle?.toLowerCase().includes(search))
      );
    })
    .sort((a, b) => {
      const aSelected = formData.members.some((m) => m.employeeId === a.EmpId);

      const bSelected = formData.members.some((m) => m.employeeId === b.EmpId);

      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;

      return a.Name.localeCompare(b.Name);
    });



  return (
    <div className="h-screen overflow-y-auto  p-6">
      {/* Header */}
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        {filteredTeams?.length === 0 ? (
          ""
        ) : (
          <div className="relative w-[50%]">
            <Search className="absolute left-3 top-3 text-gray-400" size={18} />

            <input
              type="text"
              placeholder="Search teams, owner or members..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full rounded-xl border bg-white py-2 pl-10 pr-4 outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        )}

        {/* {filteredTeams.length === 0 ? (
          ""
        ) : (
          <button
            onClick={() => {
              setIsTeamNameEditable(true);
              openAddModal();
            }}
            className="text-sm flex items-center gap-2 rounded-lg bg-green-600 py-2 px-4 font-medium text-white hover:bg-green-700"
          >
            <Plus size={18} />
            Create Team
          </button>
        )} */}
      </div>

      {/* Cards */}
      {filteredTeams?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className="h-40 w-40 text-slate-300"
            fill="currentColor"
          >
            <path d="M256 256a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm0 32c-79.5 0-144 64.5-144 144a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16c0-79.5-64.5-144-144-144zm160-32a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm0 32c-19.6 0-38.2 4.2-55 11.7 33.6 28.5 55 71 55 119.3v13h80a16 16 0 0 0 16-16c0-70.7-57.3-128-128-128zM96 256a64 64 0 1 0-64-64 64 64 0 0 0 64 64zm55 43.7C134.2 292.2 115.6 288 96 288-25.7 288-83 345.3-83 416a16 16 0 0 0 16 16h80v-13c0-48.3 21.4-90.8 55-119.3z" />
          </svg>

          <h3 className="mt-6 text-2xl font-semibold text-slate-700">
            No Inactive Teams Found
          </h3>

          <p className="mt-2 max-w-md text-center text-slate-500">
            There are currently no inactive teams available. Create a new team
            in active teams tab to start assigning leaders and members.
          </p>

          {/* <button
            onClick={() => {
              setEditingTeam(null);
              setIsTeamNameEditable(true);
              setIsOpen(true);
            }}
            className="mt-6 rounded-xl bg-green-600 px-5 py-2.5 font-medium text-white transition hover:bg-green-700"
          >
            Create Team
          </button> */}
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {filteredTeams?.map((team) => {
            const isTeamActive = team.isActive || team.ActiveStatus === "Y";
            return (
              <div
                key={team.id}
                // className="rounded-2xl border border-white/30 bg-white p-3 shadow-md transition hover:shadow-xl"
                className={`rounded-2xl border bg-white px-3 py-2  transition hover:shadow-lg
    ${team.isActive
                    ? "border-white/30"
                    : "border-red-200 bg-gray-100 opacity-70"
                  }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-bold">{team.TeamName}</h3>
                    <h5 className="text-xs font-thin">
                      {team.TeamDescription}
                    </h5>

                    <div className="flex gap-2 items-center mt-2">
                      <span className="text-xs text-gray-900">Leader:</span>{" "}
                      <img
                        className="h-6 w-6 rounded-full object-cover"
                        src={
                          team.imagepath
                            ? fetchProfilePic(team.imagepath)
                            : user1
                        }
                        alt=""
                      />
                      <span className="text-sm font-medium text-gray-900">
                        {team.TeamLeaderName}-
                        <span className="font-thin text-xs">
                          ({team.TeamLeaderID})
                        </span>
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-col justify-right items-right gap-2">
                    <span
                      className={`rounded-full px-3 py-1 text-xs text-center font-medium ${team.isActive
                          ? "bg-green-100 text-green-700"
                          : "bg-gray-200 text-gray-800"
                        }`}
                    >
                      {team.isActive ? "Active" : "Inactive"}
                    </span>
                    <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
                      {team.members?.length} members
                    </span>
                  </div>
                </div>

                <div className="mt-3 space-y-2 max-h-60 overflow-auto scrollbar-none">
                  {team.members?.map((member) => (
                    <div
                      key={member.EmployeeID}
                      className="flex items-center justify-between rounded-lg bg-gray-50 px-2 py-1 border border-gray-200"
                    >
                      <img
                        className="h-10 w-10 rounded-full object-cover"
                        src={
                          member.imagepath
                            ? fetchProfilePic(member.imagepath)
                            : user1
                        }
                        alt={member.EmployeeName}
                        onError={(e) => {
                          e.target.src = user1;
                        }}
                      />
                      <span className="text-sm">{member.EmployeeName}</span>

                      <span className="rounded bg-orange-100 px-2 py-1 text-xs text-orange-700">
                        {member.RoleInTeam}
                      </span>
                    </div>
                  ))}
                </div>

                <div className="mt-3 flex items-center justify-between gap-3">
                  <p className="text-left my-1 text-xs text-gray-500">
                    Created {dayjs(team.CreatedDate).fromNow()} •{" "}
                    {dayjs(team.CreatedDate).format("DD MMM YYYY")}
                  </p>
                  <label className="relative inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      checked={isTeamActive}
                      onChange={() =>
                        toggleTeamStatus(
                          team.TeamID || team.id,
                          team.ActiveStatus || (team.isActive ? "Y" : "N"),
                        )
                      }
                      className="peer sr-only"
                      className="peer sr-only"
                    />

                    <div
                      className="peer h-6 w-11 rounded-full bg-gray-300
      after:absolute after:left-[2px] after:top-[2px]
      after:h-5 after:w-5 after:rounded-full
      after:bg-white after:transition-all
      peer-checked:bg-green-500
      peer-checked:after:translate-x-5"
                    />
                  </label>
                  {/* <button
                  disabled={!team.isActive}
                  onClick={() => {
                    setIsTeamNameEditable(false);
                    openEditModal(team);
                  }}
                  className="rounded-lg bg-blue-50 p-2 text-blue-600 hover:bg-blue-100"
                >
                  <Pencil size={18} />
                </button> */}
                </div>
              </div>
            );
          })}
        </div>
      )}

      <ConfirmationDialog />

      {/* Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/70  p-2">
          <div className="w-full max-w-2xl max-h-[90vh] overflow-hidden rounded-3xl bg-white shadow-2xl animate-in fade-in zoom-in duration-300">
            {/* Header */}
            <div className="sticky top-0 z-10 border-b bg-white p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-slate-800">
                    {editingTeam ? "Edit Team" : "Create Team"}
                  </h2>

                  <p className="text-sm text-slate-500 mt-1">
                    Manage team members and assign responsibilities
                  </p>
                </div>

                <div className="">
                  <label className="mb-1 block text-xs font-medium text-slate-700">
                    Created On
                  </label>

                  <div className="relative">
                    <FiCalendar className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-lg pointer-events-none z-10" />

                    <DatePicker
                      selected={formData.date}
                      onChange={(date) =>
                        setFormData((prev) => ({
                          ...prev,
                          date,
                        }))
                      }
                      dateFormat="dd/MM/yyyy"
                      className="
        
        rounded-xl
        border
        border-gray-300
        bg-white
        p-2
        pr-10
        text-slate-700
        
        outline-none
        transition
        hover:border-slate-400
        focus:border-blue-500
        focus:ring-4
        focus:ring-blue-100
      "
                    />
                  </div>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="h-10 w-10 rounded-full hover:bg-slate-100 text-slate-500"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Body */}
            <div className="overflow-y-auto max-h-[65vh] px-8 py-6">
              {/* Team Information */}
              {/* <div className="grid md:grid-cols-2 gap-5 mb-8"> */}
              <div className="">
                <div>
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-slate-800">
                      Team Name
                    </h3>

                    <button
                      type="button"
                      onClick={() => setIsTeamNameEditable((prev) => !prev)}
                      className={`flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium transition ${isTeamNameEditable
                          ? "bg-green-100 text-green-700"
                          : "bg-slate-100 text-slate-600"
                        }`}
                    >
                      <div
                        className={`h-2 w-2 rounded-full ${isTeamNameEditable ? "bg-green-500" : "bg-slate-400"
                          }`}
                      />
                      {isTeamNameEditable ? "Editable" : "Locked"}
                    </button>
                  </div>

                  <input
                    disabled={!isTeamNameEditable}
                    placeholder="Enter Team Name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      })
                    }
                    className={`w-full rounded-xl border p-2 outline-none transition ${isTeamNameEditable
                        ? "border-slate-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                        : "cursor-not-allowed border-slate-200 bg-slate-100 text-slate-500"
                      }`}
                  />
                </div>

                <div>
                  <div className="">
                    <h3 className="text-lg font-semibold text-slate-800 mt-4">
                      Team Leader
                    </h3>

                    {/* SELECTED LEADER diffferent section*/}
                    {/* {selectedLeader && (
  <div className="mb-3 rounded-xl border-2 border-blue-500 bg-blue-50 p-3">
    <div className="text-xs font-semibold text-blue-600 mb-2">
      SELECTED LEADER
    </div>

    <div className="flex items-center gap-3">
      <img
        className="h-12 w-12 rounded-full object-cover"
        src={
          selectedLeader.imagepath
            ? fetchProfilePic(selectedLeader.imagepath)
            : user1
        }
        alt=""
      />

      <div>
        <div className="font-medium">
          {selectedLeader.Name}
        </div>

        <div className="text-sm text-slate-500">
          {selectedLeader.JobTitle || "Employee"} •{" "}
          {selectedLeader.Department || "No Department"}
        </div>
      </div>
    </div>
  </div>
)} */}

                    {/* Search */}
                    <input
                      placeholder="Search leader..."
                      value={leaderSearch}
                      onChange={(e) => setLeaderSearch(e.target.value)}
                      className="my-2 w-full rounded-xl border border-slate-300 p-2 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                    />

                    <div className="max-h-48 bg-gray-50 border border-gray-300 overflow-y-auto scrollbar-none rounded-xl  p-2 space-y-2">
                      {filteredLeaders?.map((emp) => {
                        const selected = formData.owner.ownerid === emp.EmpId;

                        return (
                          <div
                            key={emp.EmpId}
                            onClick={() =>
                              setFormData((prev) => ({
                                ...prev,
                                owner: {
                                  ownerid: emp.EmpId,
                                  ownerName: emp.Name,
                                },
                                members: prev.members.filter(
                                  (member) => member.employeeId !== emp.EmpId,
                                ),
                              }))
                            }
                            className={` bg-white cursor-pointer flex items-center gap-4 rounded-xl border p-3 transition-all
            ${selected
                                ? "border-blue-500 bg-blue-50"
                                : "border-slate-200 hover:border-slate-300 hover:bg-slate-50"
                              }`}
                          >
                            <img
                              className="h-12 w-12 rounded-full object-cover"
                              src={
                                emp.imagepath
                                  ? fetchProfilePic(emp.imagepath)
                                  : user1
                              }
                              alt=""
                            />

                            <div className="flex-1">
                              <h4 className="font-medium text-slate-800">
                                {emp.Name}
                                <span className="ml-2 text-xs text-slate-400">
                                  ({emp.EmpId})
                                </span>
                              </h4>

                              <p className="text-sm text-slate-500">
                                {emp.JobTitle || "Employee"} •{" "}
                                {emp.Department || "No Department"}
                              </p>
                            </div>

                            {selected && (
                              <div className="flex items-center gap-2">
                                <div className="h-2.5 w-2.5 rounded-full bg-green-500" />
                                <span className="text-sm font-medium text-blue-600">
                                  Leader
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {/* Members */}
              <div>
                <div className="mt-4 mb-2 flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-slate-800">
                      Team Members
                    </h3>

                    {/* <p className="text-sm text-slate-500">
                      Select employees and assign roles
                    </p> */}
                  </div>

                  <span className="rounded-full bg-blue-100 px-4 py-1 text-sm font-medium text-blue-700">
                    {formData.members?.length} Selected
                  </span>
                </div>

                {/* Search */}
                <input
                  placeholder="Search ..."
                  value={memberSearch}
                  onChange={(e) => setMemberSearch(e.target.value)}
                  className="mb-2 w-full rounded-xl border border-slate-300 p-2 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                />
                <div className="max-h-60 border border-gray-300 p-2 bg-gray-50  rounded-lg  overflow-y-auto scrollbar-none">
                  <div className="space-y-2 ">
                    {filteredMembers?.map((user) => {
                      const selected = formData.members.find(
                        (m) => m.employeeId === user.EmpId, // Use EmpId instead of name
                      );

                      return (
                        <div
                          onClick={() => toggleMember(user)}
                          key={user.EmpId}
                          className={`flex bg-white items-center gap-4 rounded-2xl border p-2 transition-all duration-200 
            ${selected
                              ? "border-blue-500 bg-blue-50"
                              : "border-slate-200 hover:border-slate-300 hover:bg-slate-50"
                            }`}
                        >
                          <input
                            type="checkbox"
                            checked={!!selected}
                            // onChange={() => toggleMember(user)}
                            onChange={() => { }}
                            onClick={(e) => e.stopPropagation()}
                            className="h-5 w-5 accent-blue-600 ml-2 rounded-lg"
                          />
                          <div>
                            <img
                              className="w-12 h-12 rounded-full object-cover"
                              src={
                                user.imagepath
                                  ? fetchProfilePic(user.imagepath)
                                  : user1
                              }
                              alt=""
                            />
                          </div>

                          {/* <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-500 font-semibold text-white">
                            {user.Name.split(" ")
                              .map((word) => word[0])
                              .join("")
                              .slice(0, 2)}
                          </div> */}

                          {/* Employee Info */}
                          <div className="flex-1">
                            <h4 className="font-medium text-slate-800">
                              {user.Name}
                              <span className="ml-2 text-xs font-normal text-slate-400">
                                ({user.EmpId})
                              </span>
                            </h4>
                            <p className="text-sm text-slate-500">
                              {user.JobTitle || "Employee"} •{" "}
                              {user.Department || "No Department"}
                            </p>
                          </div>

                          {/* {selected && (
                            <select
                              value={selected.role}
                              onChange={(e) =>
                                updateRole(user.EmpId, e.target.value)
                              }
                              className="rounded-xl border border-slate-300 px-4 py-2 text-sm outline-none focus:border-blue-500"
                            >
                              {roles.map((role) => (
                                <option key={role}>{role}</option>
                              ))}
                            </select>
                          )} */}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="sticky bottom-0 border-t bg-slate-50 px-8 py-4">
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsOpen(false)}
                  className="rounded-xl border border-slate-300 px-6 py-2.5 font-medium text-slate-700 transition hover:bg-slate-100"
                >
                  Cancel
                </button>
                <Tooltip
                  title={
                    disableSaveTeam
                      ? "Please fill Team name and Leader before saving"
                      : editingTeam
                        ? "Update team details"
                        : "Create a new team"
                  }
                >
                  <button
                    disabled={disableSaveTeam}
                    onClick={saveTeam}
                    className={`rounded-xl px-6 py-2.5 font-medium text-white transition hover:shadow-xl ${disableSaveTeam
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-blue-600 to-indigo-600"
                      }`}
                  >
                    {editingTeam ? "Update Team" : "Create Team"}
                  </button>
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteModalOpen && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
            <div className="flex flex-col items-center text-center">
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
                <Trash2 size={30} className="text-red-600" />
              </div>

              <h3 className="text-xl font-semibold text-slate-800">
                Delete Team
              </h3>

              <p className="mt-2 text-sm text-slate-500">
                Are you sure you want to delete
                <span className="font-semibold text-slate-700">
                  {" "}
                  {teamToDelete?.name}
                </span>
                ?
              </p>

              <p className="mt-1 text-xs text-red-500">
                This action cannot be undone.
              </p>

              <div className="mt-6 flex w-full gap-3">
                <button
                  onClick={() => {
                    setDeleteModalOpen(false);
                    setTeamToDelete(null);
                  }}
                  className="flex-1 rounded-xl border border-slate-300 py-2.5 font-medium text-slate-700 transition hover:bg-slate-100"
                >
                  Cancel
                </button>

                {/* Delete button  */}
                {/* <button
                  onClick={deleteTeam}
                  className="flex-1 rounded-xl bg-red-600 py-2.5 font-medium text-white transition hover:bg-red-700"
                >
                  Delete
                </button> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamManagement;
